module.exports = __webpack_public_path__ + "media/images/front/materials/fibra_natural-dcdfe1db6452b27592a05961b3dbe8ba.jpg";